import { Card, CardContent } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';

export function DashboardSkeleton() {
  return (
    <div className="space-y-4">
      {/* Header: title + filters left, stats card right */}
      <div className="flex items-stretch gap-0">
        <div className="flex min-w-0 flex-1 flex-col gap-3">
          {/* Page title */}
          <Skeleton className="h-8 w-52" />

          {/* Search + filter controls */}
          <div className="space-y-2">
            <div className="flex items-center gap-4">
              <Skeleton className="h-3 w-12" />
              <Skeleton className="h-3 w-12" />
            </div>
            <div className="flex items-center gap-3">
              <Skeleton className="h-8 w-52 shrink-0 rounded-md" />
              <div className="flex items-center gap-2">
                <Skeleton className="h-7 w-28 rounded-md" />
                <Skeleton className="h-7 w-32 rounded-md" />
                <div className="h-5 w-px bg-border/50" />
                <Skeleton className="h-7 w-32 rounded-md" />
                <div className="h-5 w-px bg-border/50" />
                <Skeleton className="h-7 w-36 rounded-md" />
              </div>
            </div>
          </div>
        </div>

        {/* Stats card */}
        <div className="relative z-10 w-72 shrink-0 pl-6">
          <div
            className="pointer-events-none absolute inset-y-0 -left-6 w-12"
            style={{
              background: 'linear-gradient(to right, transparent, hsl(var(--surface-1)))',
            }}
          />
          <Card
            className="bg-gradient-card"
            style={{ boxShadow: 'var(--shadow-1), var(--inset-highlight)' }}
          >
            <CardContent className="space-y-1 px-4 py-2.5">
              {Array.from({ length: 4 }).map((_, i) => (
                <div key={i} className="flex items-center justify-between">
                  <Skeleton className="h-3 w-24" />
                  <Skeleton className="h-3 w-12" />
                </div>
              ))}
            </CardContent>
          </Card>
        </div>
      </div>

      {/* Table */}
      <div className="rounded-lg border bg-card shadow-elevation-1">
        <div className="overflow-hidden">
          {/* Table header */}
          <div className="grid grid-cols-7 gap-6 border-b px-4 py-2.5">
            {['60%', '70%', '50%', '55%', '40%', '65%', '45%'].map((w, i) => (
              <Skeleton key={i} className="h-3" style={{ width: w }} />
            ))}
          </div>
          {/* Table rows — 15 rows to fill the viewport */}
          {Array.from({ length: 15 }).map((_, row) => (
            <div key={row} className="grid grid-cols-7 gap-6 border-b px-4 py-3 last:border-0">
              {['55%', '75%', '45%', '60%', '35%', '70%', '40%'].map((w, col) => {
                const jitter = (row * 7 + col) % 3 === 0 ? '10%' : col % 2 === 0 ? '-5%' : '0%';
                const pct = parseInt(w) + parseInt(jitter);
                return <Skeleton key={col} className="h-3" style={{ width: `${pct}%` }} />;
              })}
            </div>
          ))}
        </div>

        {/* Pagination */}
        <div className="flex items-center justify-between border-t px-3 py-2.5">
          <Skeleton className="h-3 w-36" />
          <div className="flex items-center gap-1">
            {Array.from({ length: 5 }).map((_, i) => (
              <Skeleton key={i} className="h-8 w-8 rounded-md" />
            ))}
          </div>
          <Skeleton className="h-3 w-24" />
        </div>
      </div>
    </div>
  );
}
